const state = {
    isSecretCourseSubscribeVisible: false,
    isTrainingTestVisible: false,
    isTrainingFeedbackVisible: false,
    secretCourseCode: null
};

const getters = {
    isSecretCourseSubscribeVisible: state => state.isSecretCourseSubscribeVisible,
    isTrainingTestVisible: state => state.isTrainingTestVisible,
    isTrainingFeedbackVisible: state => state.isTrainingFeedbackVisible,
    secretCourseCode: state => state.secretCourseCode
};

const mutations = {
    setSecretCourseSubscribeVisible: (state, data) => state.isSecretCourseSubscribeVisible = data,
    setTrainingTestVisible: (state, data) => state.isTrainingTestVisible = data,
    setTrainingFeedbackVisible: (state, data) => state.isTrainingFeedbackVisible = data,
    setActivationSecretCourseCode: (state, data) => state.secretCourseCode = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};